
<template>

    <main class="page" id="collectionsPage">

        <!-- Latest posts -->
        <section class="latest-posts">

            <div class="container py-4">

                <div class="row">

                    <div class="col text-center py-2">

                        <h2 class="text-uppercase">Filtered posts</h2>
                        <div class="divider-image divider-image-2"></div>

                    </div>
                </div>

                <div class="row" v-bind:class="{'hidden-content': !displayCollection}">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <div class="masonry" v-if="collection !== null">

                            <div class="grid-item" v-for="blog in blogs">

                                <blog-tile :blog="blog"></blog-tile>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="filtering-overlay" v-show="!displayCollection">

                    <div class="col-12 col-sm-10 offset-sm-1">

                        <p class="filtering-posts"><i class="fal fa-spin fa-spinner"></i> &nbsp; Why? Filtering, that's why.</p>

                    </div>

                </div>

                <div class="row" v-if="!hideLoadMore">

                    <div class="col text-center">

                        <a href="javascript:" @click="loadCollection(null, 10, blogs.length)" class="load-more btn btn-danger">
                            <i class="fal" :class="{'fa-spinner-third': loadingContent, 'fa-spin': loadingContent, 'fa-caret-down': !loadingContent }"></i> &nbsp; Naloži več &nbsp;
                        </a>

                    </div>
                </div>

            </div>
        </section>

    </main>

</template>

<script>
    import BlogTile from '../snippets/blog/Tile.vue';
    import Promise from 'promise-polyfill';
    import {mapState, mapActions} from 'vuex'
    import {baseSEO} from "../config";

    export default {

        components: {
            "blog-tile": BlogTile
        },

        data () {
            return {
                displayCollection: false,
                loadingContent: false,
                hideLoadMore: false
            }
        },

        computed: {

            ...mapState([
                'collection',
                'blogs'
            ]),
        },

        watch:{

            $route (to, from){

                this.loadCollection(this.$route.params.id, 10, 0, true);
            }
        },

        methods: {

            ...mapActions([
                'getCollection',
                'loadBanners'
            ]),

            getBanners: function() {

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.loadBanners().then(function(banners) {

                    if(banners.length > 0 && banners[0].image !== null && typeof banners[0].image !== "undefined") {

                        mainBackgroundImage.style.backgroundImage = "url("+handle.displayImage(banners[0].image, 2200)+")";
                    }
                });
            },

            loadCollection: function(uri, take = 10, skip = 0, override = false) {

                uri = (uri === null ? this.$route.params.id : uri);

                let handle = this;
                let mainBackgroundImage = document.getElementById("mainBackgroundImage");

                this.getCollection({uri, take, skip, override}).then(function(blogs) {

                    if(blogs.length < 10) handle.hideLoadMore = true;

                    jQuery(document).ready(function() {

                        if(handle.collection.image) mainBackgroundImage.style.backgroundImage = "url("+ handle.displayImage(handle.collection.image, 2200) +")";
                        else handle.getBanners();

                        setTimeout(function () {

                            initMasonry();

                        }, 250);

                        setTimeout(function() {

                            handle.displayCollection = true;
                        }, 500);
                    });
                });
            }

        },

        mounted: function() {

            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            this.loadCollection(this.$route.params.id, 10, 0, true);
        },

        metaInfo: function() {

            let handle = this;

            return {

                title: baseSEO.name,
                titleTemplate: '%s' + (handle.collection && typeof handle.collection.seo !== "undefined" ? " - " + handle.collection.seo.title : ""),
                meta: [
                    { author : baseSEO.author },
                    { description : (handle.collection && handle.collection.seo && typeof handle.collection.seo !== "undefined" ? (handle.collection.seo.description ? handle.collection.seo.description.replace(/\n/g, ' ').trim() : "") : baseSEO.description) },
                    { keywords : (handle.collection && typeof handle.collection.seo !== "undefined" ? handle.collection.seo.keywords : baseSEO.keywords) },

                    // Facebook
                    {property: 'og:title', content:  (handle.collection && typeof handle.collection.seo !== "undefined" ? handle.collection.seo.title : baseSEO.title) },
                    {property: 'og:site_name', content: baseSEO.name },
                    {property: 'og:type', content: 'website'},
                    {property: 'og:url', content: (handle.collection && typeof handle.collection.seo !== "undefined" ? baseSEO.url + 'collection/' + handle.collection.seo.handle : baseSEO.url) },
                    {property: 'og:image', content: (handle.collection && handle.collection.image ? baseSEO.cms + handle.collection.image.display : baseSEO.image) },
                    {property: 'og:description', content: (handle.collection && handle.collection.seo && typeof handle.collection.seo !== "undefined" ? (handle.collection.seo.description ? handle.collection.seo.description.replace(/\n/g, ' ').trim() : "") : baseSEO.description) },

                    // Twitter card
                    {name: 'twitter:card', content: 'summary'},
                    {name: 'twitter:site', content: (handle.collection && typeof handle.collection.seo !== "undefined" ? baseSEO.url + 'collection/' + handle.collection.seo.handle : baseSEO.url) },
                    {name: 'twitter:title', content: (handle.collection && typeof handle.collection.seo !== "undefined" ? handle.collection.seo.title : baseSEO.title) },
                    {name: 'twitter:description', content: (handle.collection && handle.collection.seo && typeof handle.collection.seo !== "undefined" ? (handle.collection.seo.description ? handle.collection.seo.description.replace(/\n/g, ' ').trim() : "") : baseSEO.description) },
                    {name: 'twitter:image:src', content: (handle.collection && handle.collection.image ? baseSEO.cms + handle.collection.image.display : baseSEO.image) },

                    // Google / Schema.org markup:
                    {itemprop: 'name', content: (handle.collection && typeof handle.collection.seo !== "undefined" ? handle.collection.seo.title : baseSEO.name) },
                    {itemprop: 'description', content: (handle.collection && handle.collection.seo && typeof handle.collection.seo !== "undefined" ? (handle.collection.seo.description ? handle.collection.seo.description.replace(/\n/g, ' ').trim() : "") : baseSEO.description) },
                    {itemprop: 'image', content: (handle.collection && handle.collection.image ? baseSEO.cms + handle.collection.image.display : baseSEO.image) },
                ],
                links: [
                    {rel: 'canonical', href: (handle.collection && typeof handle.collection.seo !== "undefined" ? baseSEO.url + 'collection/' + handle.collection.seo.handle : baseSEO.url) }
                ]
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/Collection.vue